export const cilCode = ["24 24","<path d='M18.22 5.54l-1.184 0.921 4.306 5.537-4.309 5.542 1.184 0.921 5.025-6.463-5.022-6.458z'></path><path d='M5.783 5.54l-5.025 6.46 5.022 6.461 1.184-0.921-4.306-5.54 4.309-5.539-1.184-0.921z'></path><path d='M8.364 23.25h1.545l5.584-22.5h-1.545l-5.584 22.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-code.js
// module id = null
// module chunks = 